/**
 * 使用动画
 *
 * @export
 * @param {
 *  Ref  动画ref
 *  container 页面节点
 *  path 动画json路径
 *  loop 是否循环
 *  autoplay 是否自动播放
 *  renderer svg
 * }
 */
export default function useAnimation(Ref, container, path, loop = false, autoplay = false, renderer = 'svg') {
  if (!Ref) return
  if (!container) return
  const El = container
  Ref.current =
    window.bodymovin &&
    window.bodymovin.loadAnimation({
      container: El,
      renderer: renderer,
      loop: loop,
      autoplay: autoplay,
      path: path,
    })
  Ref.current.addEventListener('DOMLoaded', () => {
    El.getElementsByTagName('svg')[0].style.height = 'auto'
  })
}